@if (getItems() | async; as items$$) {
  <ngb-carousel [interval]="timeout">
    @for (item$ of items$$; track item$) {
      @if (item$ | async; as item) {
        <ng-template ngbSlide>
          <ng-container *ngTemplateOutlet="template; context: { item }"></ng-container>
        </ng-template>
      }
    }
  </ngb-carousel>
}
<ng-template #template let-item="item">
    <ng-container [cxComponentWrapper]="{
        flexType: item.typeCode,
        typeCode: item.typeCode,
        uid: item?.uid
      }">
  </ng-container>
</ng-template>